// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingText_root__N3lLI","dots":"LoadingText_dots__o-LQR","loading-ellipsis":"LoadingText_loading-ellipsis__5OW4n"};